/* eslint-disable complexity */
import React, {useMemo} from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import H2 from "../../shared/h2/component";
import BuyWithConfidenceCard from "../buy-with-confidence-card/component";
import financeFirstExpImage from "./image/financeFirstExpImage.svg";
import StraightThrough from "./image/straight-through.png";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";
import { PAGE_SOURCE } from "../../../constants/app-constants";

const financeFirstExperimentObj = {
    id: "custom_pre_approval",
    text: <React.Fragment>Loan eligibility in <span>2 mins</span></React.Fragment>,
    hyperLink: "/financing/get-pre-approval",
    icon: financeFirstExpImage,
    showFinanceFirstExperimentCard: true,
    btnText: "Get Pre-approval >>"
};
const straightThroughObj = {
    id: "straight_through",
    text: <React.Fragment>12x faster<br /><span>loan approval</span></React.Fragment>,
    icon: StraightThrough,
    showStraightThroughCard: true
};

const BuyWithConfidenceRevamp = ({ buyWithConfidence = [], config = {}, personalised, preApproved,
    showHeader, quotesAvailable, source, fullWidth = false, stEligibleData }) => {
    const {isStEligible = false} = stEligibleData || {};
    const showStraightThroughCard = isStEligible && source === PAGE_SOURCE.CDP.toUpperCase();
    const showFinanceFirstExperimentVariant = true;
    const isPreApproved = personalised || preApproved || quotesAvailable;
    const handleClick = () => {
    };
    const showFinanceFirstExperimentVariantCard = showFinanceFirstExperimentVariant && !isPreApproved;
    if (isPreApproved) {
        buyWithConfidence = showStraightThroughCard ? [straightThroughObj, ...buyWithConfidence] : [...buyWithConfidence];
    } else {
        buyWithConfidence = showFinanceFirstExperimentVariantCard ? [financeFirstExperimentObj, ...buyWithConfidence] : buyWithConfidence;
    }

    const filteredBuyWithConfidence = useMemo(() =>
        buyWithConfidence.filter(item => {
            const { id = "" } = item || {};
            return !((showStraightThroughCard || showFinanceFirstExperimentVariantCard) && id === "finance_pre_approval");
        }),
    [buyWithConfidence, showStraightThroughCard, showFinanceFirstExperimentVariantCard]
    );

    return (
        <div styleName={`styles.sectionWrapper ${fullWidth ? "styles.containerSectionWrapper" : ""}`}>
            {showHeader && <H2 text="Buy with confidence" />}
            <div styleName={`styles.wrapper ${fullWidth ? "styles.containerWrapper" : ""}`}>
                {filteredBuyWithConfidence.map(item => {
                    return (<BuyWithConfidenceCard
                        cardImage={getFastlyImage(config, item.image)}
                        cardTitle={item.text}
                        onClick={() => handleClick(item.hyperLink)}
                        hyperLink={item.hyperLink}
                        showFinanceFirstExperimentCard={item.showFinanceFirstExperimentCard}
                        btnText={item.btnText}
                        icon={item.icon}
                        id={item.id}
                        source={source}
                        fullWidth={fullWidth}
                        showStraightThroughCard={item.showStraightThroughCard}
                    />);
                }
                )}
            </div>
        </div>
    );
};

BuyWithConfidenceRevamp.propTypes = {
    buyWithConfidence: PropTypes.array,
    preApproved: PropTypes.bool,
    config: PropTypes.object,
    personalised: PropTypes.bool,
    quotesAvailable: PropTypes.bool,
    showHeader: PropTypes.bool,
    source: PropTypes.string,
    fullWidth: PropTypes.bool,
    stEligibleData: PropTypes.object
};

export default BuyWithConfidenceRevamp;
